import { render, staticRenderFns } from "./CbsBpmLaunch.vue?vue&type=template&id=6568c777"
import script from "./CbsBpmLaunch.vue?vue&type=script&lang=js"
export * from "./CbsBpmLaunch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports